module.exports = __webpack_public_path__ + "img/eshop-3.5f200cd5.png";